export const headerHeight = 4;
export const contentHeight = 59.7;
export const footerHeight = 25;
